{
  "version": 1,
  "asset_id": "4c4d23bd-5fe6-43a4-b7a8-294633677077",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/4c4d23bd-5fe6-43a4-b7a8-294633677077/svc-ecommerce-seo-1200.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/4c4d23bd-5fe6-43a4-b7a8-294633677077/svc-ecommerce-seo-1200.avif",
  "original_filename": "svc-ecommerce-seo-1200.avif",
  "size": 29607,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:46Z"
}
